import axios from 'axios';
import { splitSalesOrderLines } from '@/utils/salesOrderLines';

/**
 * Pricing for everything the dashboard sells. The dashboard catalog carries
 * cost prices; configured products are priced in the browser on the
 * configurator product (selling prices), as the public forms do.
 */
export const pricingService = {
  /** Price editor lines (configured products + free lines). Nothing is saved. */
  async quote({ lines = [] }) {
    const response = await axios.post('/pricing/quote', splitSalesOrderLines(lines));
    return response.data;
  },

  /** Price one configured product; returns its main line plus option/upsell lines. */
  async quoteProduct({ productId, configuration = {}, quantity = 1, pricing = null }) {
    const result = await this.quote({
      lines: [{ kind: 'product', product_id: productId, configuration, quantity, pricing }],
    });
    return result.items.filter((item) => item.source === 'configurator');
  },

  /** Configurator-ready product (margin and VAT basis applied), same shape as the forms get. */
  async getConfiguratorProduct(productId) {
    const response = await axios.get(`/pricing/products/${productId}`);
    return response.data.product;
  },
};
